/**
 * Onboarding Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-specific/hr/EmployeeOnboarding.md
 * States: draft → invited → documentsPending → documentsComplete → contractPending → contractSigned → active
 */
export const onboardingConfig = {
    id: 'onboarding',
    initial: 'draft',
    states: {
        draft: {
            on: { INVITE: 'invited' },
        },
        invited: {
            entry: { type: 'sendInvitationEmail' },
            on: { DOCUMENTS_SUBMITTED: 'documentsPending' },
        },
        documentsPending: {
            entry: { type: 'sendDocumentReminder' },
            on: { DOCUMENTS_VERIFIED: { target: 'documentsComplete', guard: 'documentsComplete' } },
        },
        documentsComplete: {
            on: { CONTRACT_GENERATED: 'contractPending' },
        },
        contractPending: {
            entry: { type: 'sendContractForSignature' },
            on: { CONTRACT_SIGNED: { target: 'contractSigned', guard: 'contractSigned' } },
        },
        contractSigned: {
            on: { ACTIVATE: 'active' },
        },
        active: {
            entry: { type: 'activateEmployee' },
            type: 'final',
        },
    },
};
//# sourceMappingURL=onboarding.js.map